/**
 * 
 * ReferenceType Model
 *
 */

import { ApiUtils, BaseAPI } from 'soxo-bootstrap-core';


class ReferenceType extends BaseAPI {
    constructor() {
        super();

        this.fields = [
            {
                field: 'name',

                caption: 'Name',
            },
        ];
    }

    get id() {
        return 'reft_code';
    }

    get getEndpoint() {
        return 'referencetype';
    }

    get path() {
        return `referencetype`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `referencetype`;
    }
}


export default ReferenceType;
